export const composeValidators = (validator1, validator2, validator3, validator4, validator5) => {
    const validators = [validator1, validator2, validator3, validator4, validator5].filter((validator) => !!validator);
    const composedValidator = (value) => validators.reduce((result, validator) => (Object.assign(Object.assign({}, result), validator(value))), {});
    return composedValidator;
};
//# sourceMappingURL=compose-validators.js.map